import React from 'react'
import styled from 'styled-components/macro'

const CustomerSummary = ({
  activeCustomers,
  newCustomers30Days,
  totalSpend,
}) => {
  return (
    <SummaryCard>
      <StatBlock>
        <StatLabel>Active Customers</StatLabel>
        <StatValue aria-label={`${activeCustomers} active customers`}>
          {activeCustomers}
        </StatValue>
        <StatHelper>Using OMS today</StatHelper>
      </StatBlock>
      <StatBlock>
        <StatLabel>New in last 30 days</StatLabel>
        <StatValue
          aria-label={`${newCustomers30Days} new customers in the last 30 days`}
        >
          {newCustomers30Days}
        </StatValue>
        <StatHelper>Recently joined</StatHelper>
      </StatBlock>
      <StatBlock>
        <StatLabel>Total Spend</StatLabel>
        <StatValue aria-label={`Total spend: ${totalSpend}`}>
          {totalSpend}
        </StatValue>
        <StatHelper>Based on selected date range</StatHelper>
      </StatBlock>
    </SummaryCard>
  )
}

const SummaryCard = styled.section`
  background: var(--sp-color-surface);
  border-radius: var(--sp-radius-card);
  padding: var(--sp-space-xl);
  box-shadow: var(--sp-shadow-card);
  border: 1px solid var(--sp-color-border);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--sp-space-lg);
  margin-top: var(--sp-space-lg);

  @media (max-width: 768px) {
    flex-direction: column;
    padding: var(--sp-space-md);
  }
`

const StatBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sp-space-xs);
  flex: 1;
  min-width: 150px;

  @media (max-width: 768px) {
    min-width: 100%;
  }
`

const StatLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: var(--sp-color-text);
`

const StatValue = styled.div`
  font-size: 28px;
  font-weight: 600;
  color: var(--sp-color-text);
  line-height: 1.2;
`

const StatHelper = styled.div`
  font-size: 13px;
  color: var(--sp-color-muted);
  line-height: 1.4;
`

export default CustomerSummary
